import { RESTRICTION_FLAGS } from 'constants/offer';

import type { TOffer, THiddenOffer } from 'shared/types/TRankingService';

export const isPreApprovalExchangeOffer = (offer: TOffer | THiddenOffer) =>
  !!offer?.additionalInfo?.restrictionFlags?.includes(RESTRICTION_FLAGS.EXACT_CONDITION_OFFER_EXCHANGE);
